// =============================================================================
// Copyright   : 2026 semantics GmbH
// Purpose     : controlled image loading actions
// =============================================================================
// ---Framework imports
import { SILENT, createAction } from 'uix/actions';
export const requestViewerImage = createAction('REQUEST_VIEWER_IMAGE', (src, consumerId, viewerId, priority = 0)=>({
        src,
        consumerId,
        viewerId,
        priority
    }), SILENT);
export const releaseViewerImage = createAction('RELEASE_VIEWER_IMAGE', (src, consumerId)=>({
        src,
        consumerId
    }), SILENT);
export const setViewerImageState = createAction('SET_VIEWER_IMAGE_STATE', (src, state, data = {})=>({
        src,
        state,
        data
    }), SILENT);
export const removeViewerImage = createAction('REMOVE_VIEWER_IMAGE', (src)=>({
        src
    }), SILENT);
